import { Icon } from "@validereinc/common-components";
import type { ArtifactRefType } from "@validereinc/domain";
import classNames from "classnames/bind";
import React from "react";
import styles from "./InvestigationDetailPage.module.scss";

const cx = classNames.bind(styles);

export type MessageArtifactListProps = {
  artifacts: ArtifactRefType[];
};

export const MessageArtifactList = ({
  artifacts,
}: MessageArtifactListProps) => {
  if (!artifacts.length) return null;

  return (
    <div
      className={cx("message-artifact-list")}
      data-testid="message-artifact-list"
    >
      {artifacts.map((artifact) => (
        <div
          key={`${artifact.kind}-${artifact.ref.file_id}`}
          className={cx("message-artifact-list__chip")}
          data-testid="message-artifact-item"
        >
          <Icon
            variant="file-text"
            size={14}
          />
          <div className={cx("message-artifact-list__chip-copy")}>
            <div className={cx("message-artifact-list__chip-name")}>
              {artifact.name}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
